exports.components = {
  "component---src-templates-docs-js": () => import("./../../../src/templates/docs.js" /* webpackChunkName: "component---src-templates-docs-js" */),
  "component---src-templates-fullscreen-js": () => import("./../../../src/templates/fullscreen.js" /* webpackChunkName: "component---src-templates-fullscreen-js" */)
}

